import { getParsedRowByIdOrIndex, getRowsByCodice } from "./rowHelpers";
import { validateCfForImport, validatePivaForImport } from "./importValidationHelpers";
import {
  getConfirmRowDetails,
  isDittaIndividuale,
  isDittaIndividualeMulti,
  isPurePgRow,
  parseLegaleRappNomeCognomeFromItem,
} from "./importConfirmHelpers";
import {
  fetchAnagraficaByIdentity,
  getAnagraficaIdFromCreateResult,
  resolveTipoAnagIdByKey,
} from "./importAnagraficaHelpers";
import { findExistingFascicolo } from "./uploadRowsHelpers";
import {
  parseItalianDateToUtc,
  resolveMappedProfessionistaUserId,
  resolveMappedProvinciaComune,
  resolvePaeseIdFromProvincia,
} from "./creationFlowHelpers";
import { containsLetters } from "../../../../businessLogic/helpers/stringHelpers";
import {
  TIPO_ANAGRAFICA_CLIENTE_PF_KEY,
  TIPO_ANAGRAFICA_CLIENTE_PG_KEY,
  TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
  TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY,
} from "../../../../businessLogic/constants/baseTableKeys";

const postAnagraficaFascicoloByTipoKey = async ({
  anagraficaId,
  fascicoloId,
  tipoKey,
  apiTipoAnagraficaByKey,
  anagFascicoloApi,
}) => {
  const tipoAnagId = await resolveTipoAnagIdByKey(apiTipoAnagraficaByKey, tipoKey);

  await anagFascicoloApi.PostAnagraficaFascicolo(
    {
      anagraficaId,
      fascicoloId,
      tipoAnagId,
    },
    fascicoloId
  );
};

export const processPgRows = async ({
  pgRows,
  importedPGData,
  importErrorsArr,
  context,
}) => {
  const {
    parsedValues,
    selImportType,
    isAlphaNumeric,
    tenantId,
    apiAnagByCf,
    apiAnagByCfPG,
    apiTipoAnagraficaByKey,
    anagFascicoloApi,
    createCliente,
    createClienteMulti,
    createFascicolo,
    createLegaleRapp,
    createLegaleRappMulti,
    createPrestazione,
    mappedValuesList,
    parsedArrProvinceList,
    parsedArrComuniList,
    baseProvinceList,
    baseComuniList,
    apiPaeseByIdent,
    apiBasePaeseByNome,
    fascicoliCustomerList,
    logApi,
    adeApi,
    environment,
    anagraficaApi,
  } = context;

  for (let i = 0; i < pgRows.length; i++) {
    const selectedRow = pgRows[i];
    let denominazione = "";
    let cf = "";
    let pIva = "";
    let codLegalRapp = "";
    let codice = "";

    try {
      const item = getParsedRowByIdOrIndex(parsedValues, selectedRow);

      const rowDetails = getConfirmRowDetails({
        item,
        selImportType,
        isAlphaNumericFn: isAlphaNumeric,
      });
      cf = rowDetails.cf;
      pIva = rowDetails.pIva;
      denominazione = rowDetails.denominazione;
      codLegalRapp = rowDetails.codLegalRapp;
      codice = rowDetails.codice;
      const isPg = rowDetails.isPg;

      if (pIva) {
        const pivaValid = await validatePivaForImport(pIva, environment, adeApi, anagraficaApi);
        if (!pivaValid) {
          importErrorsArr.push({ denominazione, cf, pIva, reason: "Partita IVA non valida (verifica ADE)" });
          continue;
        }
      }
      if (cf && cf !== pIva && containsLetters(cf)) {
        const cfValid = await validateCfForImport(cf, environment, adeApi, anagraficaApi);
        if (!cfValid) {
          importErrorsArr.push({ denominazione, cf, pIva, reason: "Codice fiscale non valido (verifica ADE)" });
          continue;
        }
      }
      

      const related = getRowsByCodice(parsedValues, codice);

      let fascicoloResultModel = null;
      let anagByCfResponse = null;
      const clienteItem = item;

      const professionisti = [];
      professionisti.push(clienteItem[21].trimStart().trimEnd());

      const hasFascicolo =
        findExistingFascicolo(fascicoliCustomerList, {
          isPg,
          cf,
          pIva,
        }) !== null;

      if (selImportType === "aricdesktop") {
        if (!hasFascicolo) {
          const cliente = await createCliente(fascicoloResultModel, clienteItem);
          if (cliente === null || cliente === undefined) {
            throw new Error("Non è stato possibile creare correttamente il cliente");
          }
        }
      } else if (selImportType === "multi") {
        if (!hasFascicolo) {
          const clienteMulti = await createClienteMulti(fascicoloResultModel, clienteItem);
          if (clienteMulti === null) {
            throw new Error("Non è stato possibile creare correttamente il cliente");
          }
        }
      }
      anagByCfResponse = await fetchAnagraficaByIdentity({
        isPg,
        cf,
        pIva,
        tenantId,
        apiAnagByCf,
        apiAnagByCfPG,
      });

      if (hasFascicolo) {
        importErrorsArr.push({
          denominazione,
          cf,
          pIva,
          reason: "Fascicolo già presente per questa anagrafica",
        });
      } else {
        if (anagByCfResponse.data.data.anagrafica.length > 0) {
          denominazione = anagByCfResponse.data.data.anagrafica[0].Denominazione;
        }
        const fascicoloResponse = await createFascicolo(denominazione);

        if (fascicoloResponse === null || fascicoloResponse === undefined) {
          throw new Error("Non è stato possibile creare correttamente il fascicolo");
        }

        fascicoloResultModel = fascicoloResponse;
      }

      const forceLegRappTitEff =
        selImportType === "aricdesktop" && isDittaIndividuale(clienteItem, isAlphaNumeric);

      if ((codLegalRapp !== "" || forceLegRappTitEff) && selImportType === "aricdesktop") {

        for (let m = 0; m < related.length; m++) {
          const relatedItem = related[m];
          const legaleRappItem = relatedItem[41].trimStart().trimEnd();

          if (!legaleRappItem && !forceLegRappTitEff) {
            continue;
          }

          if (professionisti.filter((prof) => prof === legaleRappItem).length <= 0) {
            professionisti.push(legaleRappItem);
          }

          await createLegaleRapp(fascicoloResultModel, relatedItem, {
            forceTitolareEffettivo: forceLegRappTitEff,
          });
        }
      }

      // Per PG puri (aricdesktop): collegare al fascicolo la PF trovata in DB come legale rapp
      if (
        selImportType === "aricdesktop" &&
        fascicoloResultModel !== null &&
        isPurePgRow(clienteItem, isAlphaNumeric)
      ) {
        const parsedLegRapp = parseLegaleRappNomeCognomeFromItem(clienteItem[29] !== "" ? clienteItem : related.filter((r) => r[29].trimStart().trimEnd() !== "")[0]);
        if (parsedLegRapp) {
          const legRappResponse = await apiAnagByCf.fetch({
            tenantId,
            cf: "%%",
            cognome: "%" + parsedLegRapp.cognome + "%",
            nome: "%" + parsedLegRapp.nome + "%",
          });

          const matches = legRappResponse?.data?.data?.anagrafica ?? [];
          if (matches.length === 1) {
            const pfAnagrafica = matches[0];
            const alreadyLinked = pfAnagrafica.anagrafica_fascicolos?.some(
              (af) =>
                af.fascicolo.Id === fascicoloResultModel.id &&
                af.base_tipo_anagrafica?.Key === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY
            );
            if (!alreadyLinked) {
              await postAnagraficaFascicoloByTipoKey({
                anagraficaId: pfAnagrafica.Id,
                fascicoloId: fascicoloResultModel.id,
                tipoKey: TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
                apiTipoAnagraficaByKey,
                anagFascicoloApi,
              });
            }
          }
        }
      }

      if (
        selImportType === "multi" &&
        (isDittaIndividualeMulti(clienteItem, isAlphaNumeric) ||
          (clienteItem[19] !== "" &&
            clienteItem[20] !== "" &&
            clienteItem[21] !== "" &&
            clienteItem[28] !== ""))
      ) {
        const legaleRappResult = await createLegaleRappMulti(fascicoloResultModel, clienteItem, {
          forceTitolareEffettivo: isDittaIndividualeMulti(clienteItem, isAlphaNumeric),
        });
        if (legaleRappResult && legaleRappResult.skipped) {
          importErrorsArr.push({
            denominazione,
            cf,
            pIva,
            reason: legaleRappResult.reason,
          });
        }
      }

      const tipoAnagKey = isPg ? TIPO_ANAGRAFICA_CLIENTE_PG_KEY : TIPO_ANAGRAFICA_CLIENTE_PF_KEY;

      if (
        anagByCfResponse !== null &&
        anagByCfResponse.data.data.anagrafica.length > 0 &&
        fascicoloResultModel !== null
      ) {
        await postAnagraficaFascicoloByTipoKey({
          anagraficaId: anagByCfResponse.data.data.anagrafica[0].Id,
          fascicoloId: fascicoloResultModel.id,
          tipoKey: tipoAnagKey,
          apiTipoAnagraficaByKey,
          anagFascicoloApi,
        });
      }

      if (selImportType === "aricdesktop") {
        for (let p = 0; p < professionisti.length; p++) {
          const profItem = professionisti[p];
          const identCfProf = resolveMappedProfessionistaUserId({
            identCfProf: profItem,
            parsedArrProfList: professionisti,
            mappedValuesList,
            utentiList: [],
            loggedUserId: null,
          });

          const identData = clienteItem[22];
          const dataIdentD = parseItalianDateToUtc(identData, 1) ?? new Date();

          const addrPaeseEstero = clienteItem[10];
          const mappedAddress = resolveMappedProvinciaComune({
            provincia: clienteItem[12],
            comune: clienteItem[11],
            parsedArrProvinceList,
            parsedArrComuniList,
            mappedValuesList,
            baseProvinceList,
            baseComuniList,
          });
          const addrProvincia = mappedAddress.provincia;
          const addrComune = mappedAddress.comune;

          const paeseId = await resolvePaeseIdFromProvincia({
            provincia: addrProvincia,
            paeseEstero: addrPaeseEstero,
            fetchPaeseByIdent: apiPaeseByIdent.fetch,
            fetchPaeseByNome: apiBasePaeseByNome.fetch,
          });

          await createPrestazione(
            fascicoloResultModel,
            identCfProf,
            dataIdentD,
            paeseId,
            addrProvincia,
            addrComune
          );
        }
      }

      if (selImportType === "multi" && isPg && fascicoloResultModel !== null) {
        const legaleRappCf = item[15] ? item[15].trimStart().trimEnd() : "";
        importedPGData.push({
          cf,
          pIva,
          denominazione,
          fascicoloId: fascicoloResultModel.id,
          legaleRappCf,
          anagraficaId:
            anagByCfResponse !== null && anagByCfResponse.data.data.anagrafica.length > 0
              ? anagByCfResponse.data.data.anagrafica[0].Id
              : null,
        });
      }
    } catch (e) {
      importErrorsArr.push({
        denominazione,
        cf,
        pIva,
        reason: "Si è verificato un errore durante l'import",
      });
      logApi.AddLog(e.message, e.stack, "handleConfirmImportClick-PG", "AnagraficaImportDesktop");
    }
  }
};

export const processPfRows = async ({
  pfRows,
  importedPGData,
  importErrorsArr,
  context,
}) => {
  const {
    selImportType,
    parsedValues,
    tenantId,
    apiAnagByCf,
    apiAnagByCfPG,
    apiTipoAnagraficaByKey,
    anagFascicoloApi,
    createClienteMulti,
    createFascicolo,
    fascicoliCustomerList,
    logApi,
    adeApi,
    environment,
    anagraficaApi,
  } = context;

  if (selImportType !== "multi" || pfRows.length <= 0) {
    return;
  }

  for (let i = 0; i < pfRows.length; i++) {
    const selectedRow = pfRows[i];
    let denominazione = "";
    let cf = "";
    let pIva = "";

    try {
      const item = getParsedRowByIdOrIndex(parsedValues, selectedRow);

      cf = item[15].trimStart().trimEnd();
      pIva = item[9].trimStart().trimEnd();
      denominazione = item[1];

      const cfValid = await validateCfForImport(cf, environment, adeApi, anagraficaApi);
      if (!cfValid) {
        importErrorsArr.push({ denominazione, cf, pIva, reason: "Codice fiscale non valido (verifica ADE)" });
        continue;
      }

      const matchingPG = importedPGData.find((pg) => pg.legaleRappCf === cf);

      if (matchingPG) {
        const anagByCfResponse = await fetchAnagraficaByIdentity({
          isPg: false,
          cf,
          pIva,
          tenantId,
          apiAnagByCf,
          apiAnagByCfPG,
        });

        let pfAnagraficaId = null;

        if (anagByCfResponse !== null && anagByCfResponse.data.data.anagrafica.length > 0) {
          const pfAnagrafica = anagByCfResponse.data.data.anagrafica[0];
          pfAnagraficaId = pfAnagrafica.Id;

          const isAlreadyLegaleRapp = pfAnagrafica.anagrafica_fascicolos.some(
            (af) =>
              af.FascicoloId === matchingPG.fascicoloId &&
              af.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_LEGALE_RAPP_KEY
          );

          const isAlreadyTitolareEff = pfAnagrafica.anagrafica_fascicolos.some(
            (af) =>
              af.FascicoloId === matchingPG.fascicoloId &&
              af.base_tipo_anagrafica.Key === TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY
          );

          if (!isAlreadyLegaleRapp) {
            await postAnagraficaFascicoloByTipoKey({
              anagraficaId: pfAnagraficaId,
              fascicoloId: matchingPG.fascicoloId,
              tipoKey: TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
              apiTipoAnagraficaByKey,
              anagFascicoloApi,
            });
          }
          if (!isAlreadyTitolareEff) {
            await postAnagraficaFascicoloByTipoKey({
              anagraficaId: pfAnagraficaId,
              fascicoloId: matchingPG.fascicoloId,
              tipoKey: TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY,
              apiTipoAnagraficaByKey,
              anagFascicoloApi,
            });
          }
        } else {
          const createdPF = await createClienteMulti(null, item);
          if (createdPF !== null) {
            pfAnagraficaId = getAnagraficaIdFromCreateResult(createdPF);

            if (pfAnagraficaId) {
              await postAnagraficaFascicoloByTipoKey({
                anagraficaId: pfAnagraficaId,
                fascicoloId: matchingPG.fascicoloId,
                tipoKey: TIPO_ANAGRAFICA_LEGALE_RAPP_KEY,
                apiTipoAnagraficaByKey,
                anagFascicoloApi,
              });

              await postAnagraficaFascicoloByTipoKey({
                anagraficaId: pfAnagraficaId,
                fascicoloId: matchingPG.fascicoloId,
                tipoKey: TIPO_ANAGRAFICA_TITOLARE_EFFETTIVO_KEY,
                apiTipoAnagraficaByKey,
                anagFascicoloApi,
              });
            }
          }
        }
      } else {
        let fascicoloResultModel = null;
        const hasFascicolo =
          fascicoliCustomerList.filter((x) => x.isPg === false && x.cf === cf).length > 0;

        if (!hasFascicolo) {
          const fascicoloResponse = await createFascicolo(denominazione);
          if (fascicoloResponse !== null) {
            fascicoloResultModel = fascicoloResponse;

            const clienteMulti = await createClienteMulti(fascicoloResultModel, item);
            if (clienteMulti !== null) {
              const pfAnagraficaId = getAnagraficaIdFromCreateResult(clienteMulti);

              if (pfAnagraficaId) {
                await postAnagraficaFascicoloByTipoKey({
                  anagraficaId: pfAnagraficaId,
                  fascicoloId: fascicoloResultModel.id,
                  tipoKey: TIPO_ANAGRAFICA_CLIENTE_PF_KEY,
                  apiTipoAnagraficaByKey,
                  anagFascicoloApi,
                });
              }
            } else {
              throw new Error("Non è stato possibile creare correttamente il cliente");
            }
          }
        } else {
          importErrorsArr.push({
            denominazione,
            cf,
            pIva,
            reason: "Fascicolo già presente per questa anagrafica",
          });
        }
      }
    } catch (e) {
      importErrorsArr.push({
        denominazione,
        cf,
        pIva,
        reason: "Si è verificato un errore durante l'import della persona fisica",
      });
      logApi.AddLog(e.message, e.stack, "handleConfirmImportClick-PF", "AnagraficaImportDesktop");
    }
  }
};
